import { authorizeAxios, deauthorizeAxios } from '@/api/axios';
import sessionsApi from '@/api/v1/sessions';
import clientsApi from '@/api/v1/clients';
import developerApi from '@/api/v1/developer';

export default {
  namespaced: true,

  state: {
    token: localStorage.getItem('Bench-Auth-Token') || '',
    role: localStorage.getItem('Bench-Role') || '',
  },

  mutations: {
    SET_SESSION_DATA(state, sessionData) {
      state.token = sessionData.token;
      state.role = sessionData.source;
    },
  },

  actions: {
    login({ commit, dispatch }, userCredentials) {
      return new Promise((resolve, reject) => {
        sessionsApi.authenticate(userCredentials)
          .then((resp) => {
            const { token, source } = resp.data;
            localStorage.setItem('Bench-Auth-Token', token);
            localStorage.setItem('Bench-Role', source);
            authorizeAxios(token);
            commit('SET_SESSION_DATA', { token, source });

            dispatch('showSuccess', ['Logged in'], { root: true });
            resolve();
          })
          .catch((err) => {
            localStorage.removeItem('Bench-Auth-Token');
            localStorage.removeItem('Bench-Role');

            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },

    logout({ commit, state }) {
      return new Promise((resolve) => {
        const redirectToHrLogin = (state.role === 'hr' || state.role === 'super_hr');

        localStorage.removeItem('Bench-Auth-Token');
        localStorage.removeItem('Bench-Role');
        deauthorizeAxios();
        commit('SET_SESSION_DATA', '', '');
        resolve();

        if (redirectToHrLogin) {
          window.location = '/hr/login';
        } else {
          window.location = '/login';
        }
      });
    },

    registerClient({ commit, dispatch }, newClientData) {
      return new Promise((resolve, reject) => {
        clientsApi.accounts
          .create(newClientData)
          .then((resp) => {
            const { token } = resp.data;
            const source = 'client';
            localStorage.setItem('Bench-Auth-Token', token);
            localStorage.setItem('Bench-Role', source);
            authorizeAxios(token);
            commit('SET_SESSION_DATA', { token, source });

            dispatch('showSuccess', ['Successful registration'], { root: true });
            resolve();
          })
          .catch((err) => {
            localStorage.removeItem('Bench-Auth-Token');
            localStorage.removeItem('Bench-Role');

            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },

    registerDeveloper({ dispatch }, newDeveloperData) {
      return new Promise((resolve, reject) => {
        developerApi.accounts
          .registerDeveloper(newDeveloperData)
          .then((resp) => {
            const { token } = resp.data;
            const source = 'developer';
            localStorage.setItem('Bench-Auth-Token', token);
            localStorage.setItem('Bench-Role', source);
            authorizeAxios(token);

            dispatch('showSuccess', ['Successful registration'], { root: true });
            resolve();
          })
          .catch((err) => {
            localStorage.removeItem('Bench-Auth-Token');
            localStorage.removeItem('Bench-Role');

            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },
  },

  getters: {
    isLoggedIn(state) {
      return !!state.token;
    },

    isSuperHR(state) {
      return state.role === 'super_hr';
    },
  },
};
